import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Login from './pages/Login';
import MainLayout from './layouts/MainLayout';
import Hero from './components/home/Hero';
import AboutServices from './components/home/AboutServices';
import GoogleReviews from './components/home/GoogleReviews';

// Importy stron
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Location from './pages/Location';
import Contact from './pages/Contact';
import Admin from './pages/Admin';

const Home = () => {
  return (
    <div>
      <Hero />
      <AboutServices />
      <GoogleReviews />
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/location" element={<Location />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
        </MainLayout>
      </Router>
      <Analytics />
    </AuthProvider>
  );
};

export default App;
